module.exports = __webpack_public_path__ + "static/media/banner-welcomebonus-mobile.1b372ab2.jpg";